import React, { useEffect, useState } from 'react'
import MROFullScreenRightDrawer from 'components/MaintFullWidthRightDialog';
import ToolBar from 'components/ToolBar'
import { Box, IconButton, makeStyles, Typography, Grid, Paper } from '@material-ui/core'
import GetInfoCard from 'components/GetInfoCard'
import MROTextField from 'components/form_components/TextField';

import SaleTable from './SaleTable';
import CoreTable from './CoreTable';
import SalesSubTable from './SalesSubTable';
import SupportingDoc from 'views/Accounts/Workshop/Maintenance/ManageInvoice/SupportingDoc';
import PartSalesServices from 'lib/services/api/commercial/parts';
import { getOrganisationId } from 'lib/utils/common_utils';
import Invoices from 'views/Accounts/Workshop/Maintenance/ManageInvoice/Invoices';










const useStyles = makeStyles((theme) => ({

    wrapper: {
        margin: "2% 3%",
        height: "100vh"

    },
    subWrapper: {
        padding: "15px",
        height: "100vh"
    },
    partCard: {
        borderRadius: "3px",
        padding: "5px 10px",
        "& p": {
            fontSize: "14px",
            padding: "3px",
        },

    },
    disableField: {
        pointerEvents: "none",
        backgroundColor: "#F5F5F5",
    }, root: {
        backgroundColor: "#ffffff",

    },

}))

function ManageSales(props) {
    const classes = useStyles()
    const { handleClose, currentSelection } = props
    const [loading, setLoading] = useState(null)
    const [details, setDetails] = useState({})
    const [financeOrderList, setFinanceOrderList] = useState({})
    const [files, setFiles] = useState({})



    const getTabDetails = async () => {
        const params = {
            organisation_id: getOrganisationId(),
            sales_order_id: currentSelection.id

        }
        try {
            const response = await PartSalesServices.getTabHeaderDetails(params)

            setDetails(response)
        } catch (error) {

        }
        setLoading(false)
    }

    const getFinanceFiles = async () => {
        const params = {
            organisation_id: getOrganisationId(),
            sales_order_id: currentSelection.id

        }
        try {
            const response = await PartSalesServices.getFinanceFiles(params)

            setFiles(response)

        } catch (error) {

        }
        setLoading(false)
    }

    useEffect(() => {
        if (currentSelection !== undefined) {
            setLoading(true)

            getTabDetails()
            getFinanceFiles()
        }
    }, [currentSelection])


    useEffect(() => {
        if (details !== undefined) {
            let obj = {
                id: currentSelection.id,
                currency_id: details?.currency_id ?? " ",
                customer_sales_rate: details?.currency_sales_rate ?? " ",
                currency_code: details?.currency_name ?? " "

            }

            setFinanceOrderList(obj)
        }
    }, [details])



    return (

        <MROFullScreenRightDrawer open={true}>
            <ToolBar handleClose={handleClose} titleName={"Sales Order"} />
            <div className={classes.root}>
                <div className={classes.wrapper}>
                    <Typography color="primary" style={{ marginBottom: "10px" }}>
                        Order Details
                    </Typography>

                    <Box
                        display="flex"
                        alignItems="center"
                        justifyContent={"center"}
                        bgcolor="#F5F5F5"
                        className={classes.partCard}
                    >
                        <Box flexGrow={1}>
                            <div style={{ width: "100%" }}>
                                <GetInfoCard keyName={"Order #"} value={details?.order ?? "-"} />
                                <GetInfoCard keyName={"Customer"} value={details?.customer ?? "-"} />
                                <GetInfoCard
                                    keyName={"Customer Ref"}
                                    value={details?.customer_order ?? "-"}
                                />
                            </div>
                        </Box>
                        <Box flexGrow={1}>
                            <div style={{ width: "100%" }}>
                                <GetInfoCard keyName={"Currency"} value={details?.currency_name ?? "-"} />
                                <GetInfoCard keyName={"Rate"} value={details?.currency_name ?? "-"} />
                                <GetInfoCard
                                    keyName={"2nd Cust Ref"}
                                    value={details?.second_reference}
                                />
                            </div>
                        </Box>
                        <Box flexGrow={1}>
                            <div style={{ width: "100%" }}>
                                <GetInfoCard keyName={"Created"} value={details?.raised ?? "-"} />
                                <GetInfoCard keyName={"Created By"} value={details?.raised_by ?? "-"} />
                                <GetInfoCard keyName={"Priority"} value={details?.priority === "low" ? "Low" : details?.priority === "medium" ? "Medium" : "High"} />
                            </div>
                        </Box>
                    </Box>

                    <Grid item xs={12} style={{ marginBottom: "10px" }} >
                        <MROTextField
                            style={{ whiteSpace: 'break-spaces' }}
                            // disabled={true}
                            label={"Internal Notes"}
                            multiline
                            defaultValue={details?.internal_remarks}
                            inputProps={{ maxLength: 2000 }}
                            InputProps={{
                                className: classes.disableField,
                                style: { height: 'max-content', width: "100%" }
                            }}
                            placeholder={
                                "Enter any internal notes. These will NOT go to the customer and are for internal reference only. Max 2000 characters"
                            }
                            InputLabelProps={{ shrink: true }}
                        ></MROTextField>
                    </Grid>

                    <Typography color="primary" gutterBottom={"10px"} >
                        Sales Items
                    </Typography>
                    <SaleTable quotationId={currentSelection.id} />
                    <Typography color="primary" gutterBottom={"10px"}>
                        Core Exchange Items
                    </Typography>

                    <CoreTable salesId={currentSelection.id} permission={props?.permission} />

                    <Typography color="primary" gutterBottom={"10px"}>
                        Finance
                    </Typography>

                    <Grid container xs={12} spacing={2}>


                        <Grid item xs={4}> <SalesSubTable salesId={currentSelection.id} financeOrderList={financeOrderList} /></Grid>
                        <Grid item xs={4}>  <SupportingDoc financeOrderList={files} tabName={"Parts"} salesID={currentSelection.id} type={"SalesOrder"} id={currentSelection.id} /></Grid>
                        <Grid item xs={4}>

                            <Invoices
                                financeOrderList={financeOrderList}
                                orderType={""}
                                getFinanceWorkshopOrderList={getTabDetails}
                                currentSelection={currentSelection}
                                type={"SalesOrder"}
                                height={"315px"}
                                isInvoiceOpen={true}
                                {...props} />
                        </Grid>


                    </Grid>



                </div>







            </div>


        </MROFullScreenRightDrawer>
    )
}

export default ManageSales